import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import axios from "axios";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

const ServiceEdit1 = () => {
    const [titleName, setTitleName] = useState("");
    const [titleDescription, setTitleDescription] = useState("");
    const [titleName2, setTitleName2] = useState("");
    const [titleDescription2, setTitleDescription2] = useState("");
    const [titleName3, setTitleName3] = useState("");
    const [titleDescription3, setTitleDescription3] = useState("");
    const [titleName4, setTitleName4] = useState("");
    const [titleDescription4, setTitleDescription4] = useState("");
    const [image, setImage] = useState(null);
    const [subtitles, setSubtitles] = useState([]);
    const [imageUrl, setImageUrl] = useState("");
    const [image2, setImage2] = useState(null);
    const [imageUrl2, setImageUrl2] = useState("");
    const [image3, setImage3] = useState(null);
    const [imageUrl3, setImageUrl3] = useState("");
    const [image4, setImage4] = useState(null);
    const [imageUrl4, setImageUrl4] = useState("");
    const [editServiceId, setEditServiceId] = useState(null);

    const [serviceData, setServiceData] = useState([]);
    const [message, setMessage] = useState("");
    const [expandedSubtitles, setExpandedSubtitles] = useState({});

    const [subtitles2, setSubtitles2] = useState([]);
    const [subtitles3, setSubtitles3] = useState([]);
    const [subtitles4, setSubtitles4] = useState([]);

    useEffect(() => {
        fetchServiceData();
    }, []);

    const addSubtitle = () => {
        const newSubtitleId = subtitles.length + 1; 
        setSubtitles([...subtitles, { subtitle_id: newSubtitleId,subtitle: "", subdescription: "", subimage: null }]);
    };

    const addSubtitle2 = () => {
        const newSubtitleId = subtitles2.length + 1; 
        setSubtitles2([...subtitles2, { subtitle_id: newSubtitleId,subtitle: "", subdescription: "", subimage: null }]);
    };

    const addSubtitle3 = () => {
        const newSubtitleId = subtitles3.length + 1; 
        setSubtitles3([...subtitles3, { subtitle_id: newSubtitleId,subtitle: "", subdescription: "", subimage: null }]);
    };

    const addSubtitle4 = () => {
        const newSubtitleId = subtitles4.length + 1; 
        setSubtitles4([...subtitles4, { subtitle_id: newSubtitleId,subtitle: "", subdescription: "", subimage: null }]);
    };

    const removeSubtitle = (index) => {
        setSubtitles(subtitles.filter((_, i) => i !== index));
    };

    const removeSubtitle2 = (index) => {
        setSubtitles2(subtitles2.filter((_, i) => i !== index));
    };

    const removeSubtitle3 = (index) => {
        setSubtitles3(subtitles3.filter((_, i) => i !== index));
    };

    const removeSubtitle4 = (index) => {
        setSubtitles4(subtitles4.filter((_, i) => i !== index));
    };

    const handleSubtitleChange = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/subtitles/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles(newSubtitles);
    };


    const handleSubtitleChange2 = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles2];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle2_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/subtitles2/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles2(newSubtitles);
    };

    const handleSubtitleChange3 = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles3];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle3_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/subtitles3/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles3(newSubtitles);
    };


    const handleSubtitleChange4 = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles4];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle4_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/subtitles4/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles4(newSubtitles);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
    
        try {
            let uploadedImageUrl = imageUrl;
            if (image) {
                const imageName = `${titleName.replace(/\s+/g, '_')}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/${imageName}`);
                await imageRef.put(image);
                uploadedImageUrl = await imageRef.getDownloadURL();
            }

            let uploadedImageUrl2 = imageUrl2;
            if (image2) {
                const imageName = `${titleName2.replace(/\s+/g, '_')}_2.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/SecondSection/${imageName}`);
                await imageRef.put(image2);
                uploadedImageUrl2 = await imageRef.getDownloadURL();
            }

            let uploadedImageUrl3 = imageUrl3;
            if (image3) {
                const imageName = `${titleName3.replace(/\s+/g, '_')}_3.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/ThirdSection/${imageName}`);
                await imageRef.put(image3);
                uploadedImageUrl3 = await imageRef.getDownloadURL();
            }

            let uploadedImageUrl4 = imageUrl4;
            if (image4) {
                const imageName = `${titleName4.replace(/\s+/g, '_')}_4.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`services/FourthSection/${imageName}`);
                await imageRef.put(image4);
                uploadedImageUrl4 = await imageRef.getDownloadURL();
            }
    
            const subtitleData = await Promise.all(
                subtitles.map(async (sub, index) => {
                    if (sub.subimage && typeof sub.subimage === 'object') { 
                        // Upload subimage if it's a File object
                        const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle_${index + 1}.jpg`;
                        const storageRef = firebase.storage().ref();
                        const imageRef = storageRef.child(`services/subtitles/${imageName}`);
                        await imageRef.put(sub.subimage);
                        sub.subimage = await imageRef.getDownloadURL();
                    }
                    return {
                        subtitle_id: sub.subtitle_id,
                        subtitle: sub.subtitle || "",
                        subdescription: sub.subdescription || "",
                        subimage: sub.subimage || ""
                    };
                })
            );


            const subtitleData2 = await Promise.all(
                subtitles2.map(async (sub, index) => {
                    if (sub.subimage && typeof sub.subimage === 'object') { 
                        // Upload subimage if it's a File object
                        const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle2_${index + 1}.jpg`;
                        const storageRef = firebase.storage().ref();
                        const imageRef = storageRef.child(`services/subtitles2/${imageName}`);
                        await imageRef.put(sub.subimage);
                        sub.subimage = await imageRef.getDownloadURL();
                    }
                    return {
                        subtitle_id: sub.subtitle_id,
                        subtitle: sub.subtitle || "",
                        subdescription: sub.subdescription || "",
                        subimage: sub.subimage || ""
                    };
                })
            );

            const subtitleData3 = await Promise.all(
                subtitles3.map(async (sub, index) => {
                    if (sub.subimage && typeof sub.subimage === 'object') { 
                        // Upload subimage if it's a File object
                        const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle3_${index + 1}.jpg`;
                        const storageRef = firebase.storage().ref();
                        const imageRef = storageRef.child(`services/subtitles3/${imageName}`);
                        await imageRef.put(sub.subimage);
                        sub.subimage = await imageRef.getDownloadURL();
                    }
                    return {
                        subtitle_id: sub.subtitle_id,
                        subtitle: sub.subtitle || "",
                        subdescription: sub.subdescription || "",
                        subimage: sub.subimage || ""
                    };
                })
            );

            const subtitleData4 = await Promise.all(
                subtitles4.map(async (sub, index) => {
                    if (sub.subimage && typeof sub.subimage === 'object') { 
                        // Upload subimage if it's a File object
                        const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle4_${index + 1}.jpg`;
                        const storageRef = firebase.storage().ref();
                        const imageRef = storageRef.child(`services/subtitles4/${imageName}`);
                        await imageRef.put(sub.subimage);
                        sub.subimage = await imageRef.getDownloadURL();
                    }
                    return {
                        subtitle_id: sub.subtitle_id,
                        subtitle: sub.subtitle || "",
                        subdescription: sub.subdescription || "",
                        subimage: sub.subimage || ""
                    };
                })
            );



            const formData = {
                title: titleName,
                description: titleDescription,
                imageUrl: uploadedImageUrl,
                title2: titleName2,
                description2: titleDescription2,
                imageUrl2: uploadedImageUrl2,
                title3: titleName3,
                description3: titleDescription3,
                imageUrl3: uploadedImageUrl3,
                title4: titleName4,
                description4: titleDescription4,
                imageUrl4: uploadedImageUrl4,
                subtitles: subtitleData,
                subtitles2: subtitleData2,
                subtitles3: subtitleData3,
                subtitles4: subtitleData4,
                service_id: editServiceId || null
            };
    
            if (editServiceId) {
                await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updateService/${editServiceId}`, formData);
                setMessage("Service updated successfully!");
            } else {
                await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addService", formData);
                setMessage("Service added successfully!");
            }
    
            fetchServiceData();
            resetForm();
        } catch (error) {
            console.error("Error submitting service data:", error);
            setMessage("Failed to submit service. Please try again.");
        }
    };

    const resetForm = () => {
        setTitleName("");
        setTitleDescription("");
        setImage(null);
        setImageUrl("");
        setImage2(null);
        setImageUrl2("");
        setImage3(null);
        setImageUrl3("");
        setImage4(null);
        setImageUrl4("");
        setTitleName2("");
        setTitleName3("");
        setTitleName4("");
        setTitleDescription2("");
        setTitleDescription3("");
        setTitleDescription4("");
        setSubtitles([]);
        setSubtitles2([]);
        setSubtitles3([]);
        setSubtitles4([]);
        setEditServiceId(null);
    };

    const fetchServiceData = async () => {
        try {
            const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getServices");
            setServiceData(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error("Error fetching service data:", error);
        }
    };

    const handleEdit = (item) => {
        setTitleName(item.title);
        setTitleDescription(item.description);
        setTitleName2(item.title2);
        setTitleDescription2(item.description2);
        setTitleName3(item.title3);
        setTitleDescription3(item.description3);
        setTitleName4(item.title4);
        setTitleDescription4(item.description4);
        setImageUrl(item.imageUrl);
        setImageUrl2(item.imageUrl2);
        setImageUrl3(item.imageUrl3);
        setImageUrl4(item.imageUrl4);
        setSubtitles(item.subtitles || []);
        setSubtitles2(item.subtitles2 || []);
        setSubtitles3(item.subtitles3 || []);
        setSubtitles4(item.subtitles4 || []);
        setEditServiceId(item.service_id);
    };

    const handleDelete = async (serviceId) => {
        try {
            await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deleteService/${serviceId}`);
            setMessage("Service entry deleted successfully!");
            fetchServiceData();
        } catch (error) {
            console.error("Error deleting service entry:", error);
            setMessage("Failed to delete service entry. Please try again.");
        }
    };

    const toggleSubtitles = (serviceId) => {
        setExpandedSubtitles(prev => ({
            ...prev,
            [serviceId]: !prev[serviceId]
        }));
    };

    return (
        <div className="serviceEdit-section">
            <div className="container">
                <h2 className="text-center mb-4">Edit Service Section</h2>
                <form onSubmit={handleSubmit}>
                    <h5 className="text-center">First Section</h5>
                            <input type="text" value={titleName} className="col-md-4" onChange={(e) => setTitleName(e.target.value)} placeholder="Title Name" />
                            <input type="text" value={titleDescription} className="col-md-4" onChange={(e) => setTitleDescription(e.target.value)} placeholder="Description" />
                            {imageUrl && <div><img src={imageUrl} alt="service" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                            {subtitles2.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subtitle} className="col-md-4" onChange={(e) => handleSubtitleChange2(index, "subtitle", e.target.value)} placeholder="Subtitle" />
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange2(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    {sub.subimage && <div><img src={sub.subimage} alt="subimage" style={{ width: "100px", height: "100px" }} /></div>}
                                    <input type="file" className="col-md-4" onChange={(e) => handleSubtitleChange2(index, "subimage", e.target.files[0])} />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle2(index)}>Remove</button>
                                </div>
                            ))}
                            <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle2}>Add Subtitle</button>





                    <h5 className="text-center">Second Section</h5>
                            <input type="text" value={titleName2} className="col-md-4" onChange={(e) => setTitleName2(e.target.value)} placeholder="Title Name" />
                            <input type="text" value={titleDescription2} className="col-md-4" onChange={(e) => setTitleDescription2(e.target.value)} placeholder="Description" />
                            {imageUrl2 && <div><img src={imageUrl2} alt="service" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setImage2(e.target.files[0])} />
                            {subtitles.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subtitle} className="col-md-4" onChange={(e) => handleSubtitleChange(index, "subtitle", e.target.value)} placeholder="Subtitle" />
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    {sub.subimage && <div><img src={sub.subimage} alt="subimage" style={{ width: "100px", height: "100px" }} /></div>}
                                    <input type="file" className="col-md-4" onChange={(e) => handleSubtitleChange(index, "subimage", e.target.files[0])} />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle(index)}>Remove</button>
                                </div>
                            ))}
                        <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle}>Add Subtitle</button>



                    <h5 className="text-center">Third Section</h5>
                            <input type="text" value={titleName3} className="col-md-4" onChange={(e) => setTitleName3(e.target.value)} placeholder="Title Name" />
                            <input type="text" value={titleDescription3} className="col-md-4" onChange={(e) => setTitleDescription3(e.target.value)} placeholder="Description" />
                            {imageUrl3 && <div><img src={imageUrl3} alt="service" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setImage3(e.target.files[0])} />
                            {subtitles3.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subtitle} className="col-md-4" onChange={(e) => handleSubtitleChange3(index, "subtitle", e.target.value)} placeholder="Subtitle" />
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange3(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    {sub.subimage && <div><img src={sub.subimage} alt="subimage" style={{ width: "100px", height: "100px" }} /></div>}
                                    <input type="file" className="col-md-4" onChange={(e) => handleSubtitleChange3(index, "subimage", e.target.files[0])} />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle3(index)}>Remove</button>
                                </div>
                            ))}
                            <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle3}>Add Subtitle</button>    




                    <h5 className="p-4 text-center">Fourth Section</h5>
                    <input type="text" value={titleName4} className="col-md-4" onChange={(e) => setTitleName4(e.target.value)} placeholder="Title Name" />
                            <input type="text" value={titleDescription4} className="col-md-4" onChange={(e) => setTitleDescription4(e.target.value)} placeholder="Description" />
                            {imageUrl4 && <div><img src={imageUrl4} alt="service" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setImage4(e.target.files[0])} />
                            {subtitles4.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subtitle} className="col-md-4" onChange={(e) => handleSubtitleChange4(index, "subtitle", e.target.value)} placeholder="Subtitle" />
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange4(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    {sub.subimage && <div><img src={sub.subimage} alt="subimage" style={{ width: "100px", height: "100px" }} /></div>}
                                    <input type="file" className="col-md-4" onChange={(e) => handleSubtitleChange4(index, "subimage", e.target.files[0])} />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle4(index)}>Remove</button>
                                </div>
                            ))}
                            <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle4}>Add Subtitle</button> <br></br>



                    <button className="btn btn-primary mt-3" type="submit">Save Changes</button>
                    {message && <p>{message}</p>}
                </form>

                <h2>Service Entries</h2>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Image</th>
                            <th>Subtitles</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceData.map((item) => (
                            <tr key={item.service_id}>
                                <td>{item.title}</td>
                                <td>{item.description}</td>
                                <td><img src={item.imageUrl} alt="service" style={{ width: "50px", height: "50px" }} /></td>
                                <td>
                                    <button onClick={() => toggleSubtitles(item.service_id)}>
                                        {expandedSubtitles[item.service_id] ? <FaArrowUp /> : <FaArrowDown />}
                                    </button>
                                </td>
                                <td><button onClick={() => handleEdit(item)}>Edit</button></td>
                                <td><button onClick={() => handleDelete(item.service_id)}>Delete</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {serviceData.map((item) => (
                    expandedSubtitles[item.service_id] && (
                        <div key={`subtitle-table-${item.service_id}`}>
                            <h4>Subtitles for {item.title}:</h4>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Subtitle</th>
                                        <th>Subdescription</th>
                                        <th>Subimage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.subtitles2.map((sub, index) => (
                                        <tr key={index}>
                                            <td>{sub.subtitle}</td>
                                            <td>{sub.subdescription}</td>
                                            <td>
                                                {sub.subimage && <img src={sub.subimage} alt="subimage" style={{ width: "50px", height: "50px" }} />}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default ServiceEdit1;
